import Shortkey from 'vue-shortkey'
import Vue from 'vue'

Vue.use(Shortkey)
